const translations = {
  "en": {
    "Thinking completed %{var0}": "Thinking completed %{var0}"
  },
  "zh-tw": {
    "Thinking completed %{var0}": "思考完成 %{var0}"
  }
};

export default translations;
